import { LeadModel, SuperBit_swaggerClient, LeadFilterModel, PolicyFilterModel, RenewalsSalespersonPolicies, RenewalsFilterModel } from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class DynamicColumnsModel {
    client: any;
    constructor() {
        this.init();
    }

    async fetchData() {
        let apiUrl = undefined;
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            apiUrl = jsonData.apiUrl;
            localStorage.setItem('apiUrl', apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
        return apiUrl;
    };

    async init() {
        let apiUrl = localStorage.getItem('apiUrl');
        if (!apiUrl) {
            apiUrl = await this.fetchData();
        }
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        this.client = new SuperBit_swaggerClient(url);//(settings.apiUrl);
    }

    async DynamicColsGetAllModules() {
        return await this.client.DynamicColsGetAllModules();
    };

    async DynamicColsGetDynamicColsByModuleId(moduleId: string) {
        return await this.client.DynamicColsGetDynamicColsByModuleId(moduleId);
    };

    async DynamicColsGetUserDynamicColsByModuleId(moduleId: string) {
        return await this.client.DynamicColsGetUserDynamicColsByModuleId(moduleId);
    };

    async DynamicColsGetUserDynamicColsNamesByModuleName(moduleId: string) {
        return await this.client.DynamicColsGetUserDynamicColsNamesByModuleName(moduleId);
    };

    

    async DynamicColsAddUserDynamicCol(DynamicColId:string) {
        return await this.client.DynamicColsAddUserDynamicCol(DynamicColId);
    };

    async DynamicColsRemoveUserDynamicCol(DynamicColId:string) {
        return await this.client.DynamicColsRemoveUserDynamicCol(DynamicColId);
    };
}